module.exports = __webpack_public_path__ + "img/zxjy.7730c569.png";